import React from 'react';
import './ButtonText.scss';

const ButtonText = props => (
  <button type="button" onClick={props.onClick} className="button button--text">{props.children}</button>
);

export default ButtonText;
